var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth, persistent: "" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-card",
        { staticClass: "resizable-card", class: { "no-select": _vm.resizing } },
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                { staticClass: "no-gutters" },
                [
                  _c("span", { staticClass: "headline" }, [
                    _vm._v("Preview " + _vm._s(_vm.type?.name)),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-1",
                      attrs: { color: "green" },
                      on: { click: _vm.exportToJSON },
                    },
                    [_vm._v("Export")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-1",
                      attrs: { color: "orange" },
                      on: { click: _vm.onPressImportJson },
                    },
                    [_vm._v("Import")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-1",
                      attrs: { color: "red darken-1" },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-1",
                      attrs: { color: "blue darken-1" },
                      on: { click: _vm.save },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _vm.modelCollection.length <= 1000000
                ? _c("codemirror", {
                    staticClass: "cm-editor",
                    attrs: { options: _vm.cmOpt },
                    model: {
                      value: _vm.modelCollection,
                      callback: function ($$v) {
                        _vm.modelCollection = $$v
                      },
                      expression: "modelCollection",
                    },
                  })
                : _c(
                    "div",
                    [
                      _c("v-alert", { attrs: { type: "error", dense: "" } }, [
                        _vm._v(
                          " The content is too large to be displayed. Please export it to view the full content. "
                        ),
                        _c("br"),
                        _vm._v(
                          " Is still possible to import a JSON file with updated content and proceed to Save. "
                        ),
                        _c("br"),
                        _vm._v(" Validations will still occur on Save. "),
                      ]),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ml-1",
                  attrs: { color: "red darken-1" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-1",
                  attrs: { color: "blue darken-1" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
          _c("input", {
            ref: "uploaderJson",
            staticClass: "d-none",
            attrs: { type: "file", accept: "application/json" },
            on: { change: _vm.onFileChangedJson },
          }),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }